import { StateStorage } from 'zustand/middleware'
import { createStore } from '../.'
import { Locale } from '../../clients/CacheClient'

interface LocalesInterface {
  locales: Locale[]
  setLocales: (locales: Locale[]) => void
  userLocale: Locale
  setUserLocale: (locale: Locale) => void
}

export const USA_LOCALE = {
  id: 'USA',
  currency: {
    symbol: '$',
    code: 'usd',
    usdExchangeRate: 1,
    name: 'United States dollar',
  },
  numberFormat: 'en-US',
  flagEmoji: '🇺🇸',
}

export const createLocalesStore = (storage: StateStorage) =>
  createStore<LocalesInterface>(
    storage,
    (set, get) => ({
      locales: [USA_LOCALE],
      userLocale: USA_LOCALE,
      setLocales: (locales) => {
        const { userLocale } = get()
        const newUserLocale = locales.find((l) => l.id === userLocale.id)

        set({ locales, userLocale: newUserLocale || USA_LOCALE })
      },
      setUserLocale: (userLocale) => {
        set({ userLocale })
      },
    }),
    {
      persist: {
        name: 'locales',
        version: 0,
      },
    }
  )
